import React from "react";
import FinancialPlanningbanner from "../../AVHRBanner/FinancialPlanningNB.png";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { FaWallet, FaBook, FaChartLine, FaCreditCard } from "react-icons/fa";
import FinancialPlanningimg from "../../Images/FinancialPlanningOneimg.png";

function FinancialPlanning() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={FinancialPlanningbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour-B">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">Financial Planning</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}>
            <h1 className="mb-2 avhrProject-h1">
              Secure Your Financial Future with Expert Planning
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{fontSize: "20px"}}>
              Plan your finances with expert guidance to achieve your
              educational and career goals stress-free
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center px-6 py-10"
          style={{ backgroundColor: "#fcf3f7" }}>
          {/* Left Text Content */}
          <div>
            <h2 className="text-2xl md:text-3xl mb-4 avhrProject-h2">
              Areas We Cover:
            </h2>
            <p className=" avhrProject-p">
              Our financial planning services are designed to help you manage your money wisely, reduce financial stress, and achieve both short-term and long-term goals
            </p>
          </div>
        </div>

        <div
          className="grid align-items-center px-3 md:px-6 py-2"
          style={{ backgroundColor: "#fcf3f7" }}>
          <div className="col-12 lg:col-6">
            <div className="flex items-start gap-3 mb-2">
              {/* <FaWallet className="circelcolour text-5xl mt-2" /> */}
                  <span className="text-5xl mt-4">💰</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Budgeting & Saving</h3>
                <p className=" avhrProject-p">
                  Create effective monthly budgets and savings plans for
                  long-term stability
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="flex items-start gap-3 mb-2">
              {/* <FaBook className="circelcolour text-5xl mt-2" /> */}
               <span className="text-5xl mt-4">🎓</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Education Funding</h3>
                <p className=" avhrProject-p">
                  Explore funding options and scholarships for academic
                  pursuits
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="flex items-start gap-3 mb-2">
              {/* <FaChartLine className="circelcolour text-5xl mt-2" /> */}
              <span className="text-5xl mt-4">📈</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Investment Guidance</h3>
                <p className=" avhrProject-p">
                  Learn safe and smart investment strategies for wealth
                  building
                </p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="flex items-start gap-3 mb-2">
              {/* <FaCreditCard className="circelcolour text-5xl mt-2" /> */}
                <span className="text-5xl mt-4">💳</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Debt Management</h3>
                <p className=" avhrProject-p">
                  Manage and reduce debts with expert repayment strategies
                </p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="col-12 lg:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={FinancialPlanningimg}
              alt="Outcomes Illustration"
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>

        <Card
          className="CARDCOLOUR m-3"
          style={{
            background: "linear-gradient(45deg, #F8682C, #FFC300)",
          }}>
          <p className="mb-2 text-center avhrProject-p">Get Started</p>
          <h2 className="mt-2 text-center avhrProject-h2 ">
            Drive innovation through meaningful collaboration
          </h2>

          <div className="flex justify-content-center">
            <Button
              label="Contact Us"
              rounded
              onClick={() => handleNavigate("/contactus")}
              className="buttonAvhrProject"
            />
          </div>
        </Card>
      </div>
    </>
  );
}

export default FinancialPlanning;
